import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { deleteInquiryDraft } from '@api/inquiries';

export const handleDeleteInquiryDraft = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  { id: number }
>('deleteInquiryDraft', ({ id }) => deleteInquiryDraft(id));
